import { render, staticRenderFns } from "./CardItems.vue?vue&type=template&id=4450e4cd&"
import script from "./CardItems.vue?vue&type=script&lang=js&"
export * from "./CardItems.vue?vue&type=script&lang=js&"
import style0 from "./CardItems.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports